import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { ETenderViewAllFieldsAdminDTO, ETenderViewAllFieldsDTO } from 'src/app/shared/models/e-tender.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-tender-view-all-fields',
  templateUrl: './tender-view-all-fields.component.html',
  styles: []
})
export class TenderViewAllFieldsComponent implements OnInit {
  isSupplierAvailabale = false;
  isAdmin;
  private tenderRequestId = '';
  displayedLang: string;
  responseObj: ResponseObject;
  model: any;
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl + AppConfig.settings.apiServer.ETenderUploadsFolder + '/';


  subscription: Subscription;
  supplierEmailList: string = "";
  constructor(private authSrevice: AuthenticationService, private globalSrv: GlobalServices,
    private etenderSrv: EtenderService) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'Ar' : 'En';
    this.isSupplierAvailabale = history.state.data != undefined && history.state.data.supplierId != undefined;
    this.isAdmin = this.authSrevice.currentUserValue.IsAdmin;
    //this.isAdmin = this.globalSrv.user.IsAdmin;
    if (history.state.data && history.state.data.tenderId) {
      this.tenderRequestId = history.state.data.tenderId;
      this.setFormMode();
      const source = interval(600000);
      this.subscription = source.subscribe(val => this.setFormMode());

    } else if (history.state.data && history.state.data.requestId) {
      this.tenderRequestId = history.state.data.requestId;
    } else {
      window.history.back();
    }
  }


  ngOnDestroy() {
  this.subscription.unsubscribe();
  }

  ngOnInit() {

  }
  setFormMode(): void {
    // Edit Mode / Display Mode
    if (this.tenderRequestId != null) {
      this.globalSrv.isLoaderEnabled = true;
      // Get Long Haul Request by Id
      if (this.isAdmin){
        // If Admin (Coming from Tender List), View tender's Supplier List 
        this.getTenderRequestAdmin();
      }else{
        this.getTenderRequest();
      }
    } else {
      window.history.back();
    }
  }
  getTenderRequestAdmin(): void {
    this.etenderSrv.GetTenderViewAllFieldsAdminById(this.tenderRequestId, this.displayedLang).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompletedAdmin();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequest(): void {
    this.etenderSrv.GetTenderViewAllFieldsById(this.tenderRequestId, this.displayedLang).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompleted();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequestCompletedAdmin(): void {
    if (this.responseObj.Success) {
      this.model = this.responseObj.Data as ETenderViewAllFieldsAdminDTO;
      if (this.model.BookletCopy != '') {
        this.model.BookletCopy = this.uploadUrl + this.model.BookletCopy;
      }
      if (this.model.CancellationCopy != '') {
        this.model.CancellationCopy = this.uploadUrl + this.model.CancellationCopy;
      }
      this.model.ETenderSuppliersList.forEach(element => {
        this.supplierEmailList += element.ContactPersonEmail + ";";
      });
      this.globalSrv.isLoaderEnabled = false;
      // Disable Loader
    } else {
      // Enable Error
    }
  }
  getTenderRequestCompleted(): void {
    if (this.responseObj.Success) {
      this.model = this.responseObj.Data as ETenderViewAllFieldsDTO;
      if (this.model.BookletCopy != '') {
        this.model.BookletCopy = this.uploadUrl + this.model.BookletCopy;
      }
      if (this.model.CancellationCopy != '') {
        this.model.CancellationCopy = this.uploadUrl + this.model.CancellationCopy;
      }
      this.globalSrv.isLoaderEnabled = false;
      // Disable Loader
    } else {
      // Enable Error
    }
  }
}
